import { useState, useMemo, useEffect } from "react";
import CrossIcon from "../../../../assets/icons/maid-module-icons/CrossIcon.svg";
import BlueArrow from "../../../../assets/icons/maid-module-icons/BlueArrow.svg";
import BuildingIcon from "../../../../assets/icons/maid-module-icons/buildingsIcon.svg";
import { commonAPI } from "../../../../services/CommonAPIService";
import FlatSelectorModal from "../modals/FlatSelectorModal";

const UpdateFlats = ({ show, onHide, staffDetails, staffId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showFlatSelector, setShowFlatSelector] = useState(false);
  const [selectedFlats, setSelectedFlats] = useState([]);

  const myUserData = useMemo(() => {
    const auth = localStorage.getItem("userData");
    if (!auth) return null;
    return JSON.parse(auth);
  }, []);

  useEffect(() => {
    if (show && staffDetails?.lstFlats) {
      setSelectedFlats(
        staffDetails.lstFlats.map((flat) => ({
          flatId: flat.flatId,
          towerId: flat.towerId,
          flatName: flat.flatName,
          towerName: flat.towerName,
        }))
      );
      setShowFlatSelector(false);
    }
  }, [show, staffDetails]);

  if (!show) return null;

  const handleFlatSelectorContinue = (flats) => {
    setSelectedFlats(flats);
    setShowFlatSelector(false);
  };

  const removeFlat = (flatId) => {
    setSelectedFlats((prev) => prev.filter((f) => f.flatId !== flatId));
  };

const handleSave = async () => {
  if (!myUserData) {
    alert("User data not found. Please log in again.");
    return;
  }

  if (!staffId) {
    alert("Staff details not available.");
    return;
  }

  setLoading(true);

  let payload = null; 

  try {
    const originalFlats = staffDetails?.lstFlats || [];
    const originalFlatIds = originalFlats.map((f) => f.flatId).sort();
    const selectedFlatIds = selectedFlats.map((f) => f.flatId).sort();

    const hasChanges =
      originalFlatIds.length !== selectedFlatIds.length ||
      !originalFlatIds.every((id, index) => id === selectedFlatIds[index]);

    if (!hasChanges) {
      alert("No changes detected.");
      onHide();
      return;
    }

    payload = {
      staffId: staffId,
      lstFlats: selectedFlats.map((flat) => ({
        towerId: flat.towerId,
        flatId: flat.flatId,
      })),
      modifiedUserId: String(staffId),
    };

    const response = await commonAPI(
      "UpdateServiceStaffDetail",
      payload,
      { buildingId: myUserData?.buildingId }
    );

    if (response?.success === true) {
      onSuccess();
      onHide();
    } else {
      alert(response?.message || "Failed to update flats");
    }

  } catch (error) {
    console.error("Error updating flats:", error);

    const bodyError = {
      userId: myUserData?.userId,
      mobileNumber: myUserData?.mobileNumber,
      requestJSON: payload ? JSON.stringify(payload) : null,
      uri: "/api/User/ServiceStaffV1",
      errorSource: "CuroNextPortal",
      errorNumber: "UPDFLAT01",
      errorSummary: error?.message,
      errorDescription: error?.message,
      fileClassName: "UpdateFlats.js",
      functionName: "handleSave",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    alert("An error occurred. Please try again.");
  } finally {
    setLoading(false);
  }
};
  
  if (showFlatSelector) {
    return (
     
     <>
    
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 1080,
          }}
        />

      
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1095,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 16px",
          }}
        >
          <div
            className="bg-white d-flex flex-column"
            style={{
              width: "100%",
              maxWidth: 600,
              height: "96vh",
              maxHeight: "calc(100vh - 32px)",
              borderRadius: 18,
              overflow: "hidden",
              fontFamily: "Inter, sans-serif",
              padding: "16px",
            }}
          >
            <FlatSelectorModal
              initialSelected={selectedFlats}
              onBack={() => setShowFlatSelector(false)}
              onContinue={handleFlatSelectorContinue}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1080,
        }}
        onClick={onHide}
      />

      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1090,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 16px",
          pointerEvents: "none",
        }}
      >
        <div
          className="bg-white d-flex flex-column"
          style={{
            width: "100%",
            maxWidth: 600,
            height: "96vh",
            maxHeight: "calc(100vh - 32px)",
            borderRadius: 18,
            overflow: "hidden",
            fontFamily: "Inter, sans-serif",
            pointerEvents: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="d-flex justify-content-between align-items-center text-white"
            style={{
              backgroundColor: "#1C80D2",
              padding: "12px 16px",
            }}
          >
            <div className="d-flex align-items-center gap-2">
           
              <h5
                className="mb-0"
                style={{
                  fontSize: "clamp(14px, 4vw, 18px)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Update Flats
              </h5>
            </div>
            <button
              className="btn p-0 d-flex align-items-center justify-content-center bg-white"
              style={{
                width: 24,
                height: 24,
                borderRadius: 6,
                flexShrink: 0,
              }}
              onClick={onHide}
            >
              <img src={CrossIcon} alt="cross" />
            </button>
          </div>

          <div
            className="flex-grow-1"
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              padding: "16px",
            }}
          >
            <label
              style={{
                fontWeight: 600,
                marginBottom: 8,
                fontSize: "clamp(12px, 2.5vw, 13px)",
                color: "#6b7280",
              }}
            >
              Search Flat
            </label>

            <div
              onClick={() => setShowFlatSelector(true)}
              style={{
                border: "1px solid #C4C4C4",
                borderRadius: 8,
                padding: "12px 14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                background: "#fff",
              }}
            >
              <img
                src={BuildingIcon}
                alt="building"
                style={{
                  width: "clamp(16px, 4vw, 18px)",
                  height: "auto",
                }}
              />
              <span
                style={{
                  color: "#111827",
                  fontWeight: 600,
                  fontSize: "clamp(13px, 3vw, 14px)",
                }}
              >
                Add Flat
              </span>
            </div>

            {selectedFlats.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  marginTop: 16,
                }}
              >
                {selectedFlats.map((flat) => (
                  <div
                    key={flat.flatId}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      background: "#1C80D2",
                      color: "#fff",
                      borderRadius: 6,
                      padding: "6px 10px",
                      fontWeight: 600,
                      fontSize: "clamp(12px, 2.5vw, 14px)",
                      position: "relative",
                    }}
                  >
                    {flat.towerName}-{flat.flatName}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFlat(flat.flatId);
                      }}
                      style={{
                        position: "absolute",
                        top: -8,
                        right: -8,
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #fff",
                        background: "#e53935",
                        color: "#fff",
                        fontSize: 10,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        lineHeight: 1,
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ padding: "16px" }}>
            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={onHide}
                className="btn"
                style={{
                  flex: 1,
                  background: "#FFFFFF",
                  color: "#1C80D2",
                  borderRadius: 30,
                  padding: "clamp(12px, 3vw, 14px)",
                  fontWeight: 600,
                  fontSize: "clamp(14px, 3vw, 15px)",
                  border: "1px solid #1C80D2",
                }}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="btn"
                style={{
                  flex: 1,
                  background: "#1C80D2",
                  color: "#FFFFFF",
                  borderRadius: 30,
                  padding: "clamp(12px, 3vw, 14px)",
                  fontWeight: 600,
                  fontSize: "clamp(14px, 3vw, 15px)",
                  border: "none",
                }}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateFlats;